import { render, staticRenderFns } from "./LmDocumentPreview.vue?vue&type=template&id=dc090768&scoped=true&"
import script from "./LmDocumentPreview.vue?vue&type=script&lang=js&"
export * from "./LmDocumentPreview.vue?vue&type=script&lang=js&"
import style0 from "./LmDocumentPreview.vue?vue&type=style&index=0&id=dc090768&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc090768",
  null
  
)

export default component.exports